import React, { useEffect, useMemo, useState } from 'react'
import UserService from '../../services/user/UserService'
import Negara from '../../utilities/Negara'
import { Button, Col, Form, Modal, OverlayTrigger, Row, Spinner, Tooltip } from 'react-bootstrap'
import { FaDownload } from 'react-icons/fa'
import DataTable from 'react-data-table-component'

const PartnerModal = ({ showPartnerModal, handleClosePartnerModal, setDisabledForm }) => {

    let userService = useMemo(() => new UserService(), [])

    const columns = [
        {
            name: 'Nama',
            cell: row => row['nama']
        },
        {
            name: 'Alamat',
            cell: row => row['alamat']
        },
        {
            name: 'Negara',
            cell: row => <Negara id={row['negara']} />
        },
        {
            name: 'Action',
            cell: row => (
                <div className="row">
                    <div className="col-12 mb-1">
                        <OverlayTrigger placement="bottom" overlay={
                            <Tooltip >Pilih</Tooltip>}>

                            <Button size="sm" variant="primary" onClick={() => pilihDataPartner(row)}>
                                <FaDownload /> Pilih
                            </Button>
                        </OverlayTrigger>
                    </div>
                </div>
            )
        }
    ]

    const [listData, setListData] = useState([])
    const [size, setSize] = useState(10)
    const [totalData, setTotalData] = useState(0)
    const [loading, setLoading] = useState(false)

    const pilihDataPartner = (row) => {
        setDisabledForm(true)
        handleClosePartnerModal(row)
    }

    useEffect(() => {
        const fetchAllData = async () => {
            try {
                setLoading(true)
                const resPartner = await userService.listPartner(null, 0, 10)
                setListData(resPartner.data.data)
                setTotalData(resPartner.data.totalData)
                setLoading(false)
            } catch (error) {
                setLoading(false)
                setListData([])
            }
        }
        fetchAllData()
    }, [userService])

    const handleChangePage = async (page) => {
        setLoading(true)
        const resPartner = await userService.listPartner(null, page - 1, size)
        setListData(resPartner.data.data)
        setTotalData(resPartner.data.totalData)
        setLoading(false)
    }

    const handlePerRowsChange = async (size, page) => {
        setLoading(true)
        const _res = await userService.listPartner(null, page - 1, size)
        setListData(_res.data.data)
        setSize(size)
        setLoading(false)
    }

    const onChangeSearchPartner = async (e) => {
        setLoading(true)
        const _res = await userService.listPartner(e.target.value, 0, size)
        setListData(_res.data.data)
        setSize(size)
        setLoading(false)
    }


    return (
        <>
            <Modal
                show={showPartnerModal}
                onHide={handleClosePartnerModal}
                backdrop='static'
                keyboard={false}
                size='xl'
                centered
            >
                <Modal.Header>
                    <h6>Pilih Data Partner</h6>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-sm-6">
                            <Form>
                                <Form.Group as={Row} className="form-group">
                                    <Form.Label column sm="4" className="control-label align-self-center mb-0" htmlFor="searchNib">Cari Nama Partner</Form.Label>
                                    <Col sm="6">
                                        <Form.Control type="text" placeholder="Nama Partner" className="form-control-sm" onChange={(e) => onChangeSearchPartner(e)} />
                                    </Col>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                    <div className="table-responsive border-bottom my-3">
                        {loading && <Spinner />}
                        <DataTable
                            customStyles={{ headCells: { style: { 'background-color': '#00acee', 'color': 'white' } } }}
                            columns={columns}
                            data={listData}
                            highlightOnHover
                            pagination
                            paginationServer
                            paginationTotalRows={totalData}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handlePerRowsChange}
                            persistTableHead={true}
                        />
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default PartnerModal